import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Alert } from 'antd';

class Errors extends Component {
  render() {
    if (this.props.errors === null) return null;
    return (
        <div>
            <Alert
                message="Error"
                description={this.props.errors.message}
                type="error"
                showIcon
            />
        </div>
    );
  }
}

Errors.propTypes = {
    errors: PropTypes.object,
}

const mapStateToProps = (state) => ({
    errors: state.errors.errors,
});

const mapDispatchToProps = () => ({
    
});

const ErrorContainer = connect(mapStateToProps,mapDispatchToProps)(Errors);

export default ErrorContainer;


// WEBPACK FOOTER //
// ./src/errors/ErrorContainer.js